import { Badge, Switch, buttonVariants } from '@wundo/ui';
import { helpUrl } from '@wundo/shared/helpUrl.ts';
import { m } from '@/paraglide/messages.js';
import { getLocale } from '@/paraglide/runtime.js';

interface NotetakerChoiceProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
}

/** The notetaker switch, recommended, with a link to what it does. */
export function NotetakerChoice({ checked, onCheckedChange }: NotetakerChoiceProps) {
  return (
    <div className='mt-4.5 flex items-center justify-between gap-4 rounded-md border border-line bg-fill-faint px-4 py-3.5'>
      <div className='flex flex-col items-start gap-1'>
        <p className='flex flex-wrap items-center gap-2 text-base font-bold text-ink'>
          {m.onboarding_notetaker()}
          <Badge tone='accent'>{m.onboarding_notetaker_recommended()}</Badge>
        </p>
        <a
          href={helpUrl(getLocale(), 'managers/notetaker/')}
          target='_blank'
          rel='noopener noreferrer'
          className={buttonVariants({ variant: 'link', size: 'sm' })}
        >
          {m.onboarding_notetaker_help()}
        </a>
      </div>
      <Switch
        aria-label={m.onboarding_notetaker()}
        checked={checked}
        onCheckedChange={onCheckedChange}
      />
    </div>
  );
}
